const translations = {
  "en": {
    "No Data Yet": "No Data Yet",
    "No data yet, but exciting updates are on the horizon!": "No data yet, but exciting updates are on the horizon!",
    "No search results yet": "No search results yet"
  },
  "zh-tw": {
    "No Data Yet": "尚無資料",
    "No data yet, but exciting updates are on the horizon!": "暫無資料，精彩更新即將上線！",
    "No search results yet": "暫無搜尋結果"
  }
};

export default translations;
